import { registerPlugin } from "@mailonline/dmg-ads-core/src/plugin-registry";

registerPlugin("account", {
  gdpr: { enabledIfDissent: true },
  ccpa: { enabledIfDissent: true },
  init
});

function init({ broker, getConfig }) {
  const account = getConfig('site', global.location.host)
  const configVersion = getConfig('__generated.commit.sha')
  broker.register('call for page analytics', () => ({ account, configVersion }))
}
